import { extractNameFromEmail } from '@/utilities/helpers'
import { fb } from '@/utilities/db-helpers'

export const guestUser = {
  uid: `guest`,
  email: `guest`,
}

export default {
  namespaced: true,

  state: () => ({
    meta: guestUser,
  }),

  getters: {
    loggedIn: ({ meta }) => meta.uid !== `guest`,
    uid: ({ meta }) => meta.uid,
    user: ({ meta }) => meta,
    username: ({ meta }) => extractNameFromEmail(meta.email),
  },

  actions: {
    setUser({ commit }, user) {
      user = user || guestUser
      const { uid, email } = user
      return commit(`doSetUser`, { uid, email })
    },

    logout() {
      return fb.auth().signOut()
    },
  },

  mutations: {
    doSetUser(state, user) {
      state.meta = user
    },
  },
}
